import { FC } from 'react';
import BottomDrawer from 'src/common/components/dockyard/BottomDrawer';
import PanelNavigation from 'src/common/components/dockyard/PanelNavigation';
import InquiryBanner from 'src/common/components/InquiryBanner';
import { TRIP_CART_PANEL_CALENDAR, TRIP_CART_PANEL_PRICE_DETAILS, TRIP_CART_PANEL_ROOT } from 'src/listing/constants';
import TripCartPanelCalendar from 'src/trip-cart-deprecated/components/panel/TripCartPanelCalendar';
import TripCartDrawerRoot from 'src/trip-cart-deprecated/components/drawer/TripCartDrawerRoot';
import TripCartSummary from 'src/trip-cart-deprecated/components/drawer/TripCartSummary';
import { useTripCartContext } from 'src/trip-cart-deprecated/hooks/useTripCartContext';
import TripCartPanelPriceDetails from 'src/trip-cart-deprecated/components/panel/TripCartPanelPriceDetails';
import useGalleryView from 'src/listing/hooks/useGalleryView';
import styles from './TripCartDrawer.module.scss';

const TripCartContent: FC = () => {
  const {
    threadId,
    activePanel,
    panelDirection,
    isOpen,
    setOpen,
    panelType,
    snoozeActive,
  } = useTripCartContext();
  const { isGalleryViewOpen } = useGalleryView();

  // Animates into place at start. If always added, calculations will be incorrect when invisible
  if (panelType === 'aside') {
    return null;
  }
  return (
    <BottomDrawer
      isOpen={isOpen}
      setOpen={setOpen}
      highlightReveal
      hidden={isGalleryViewOpen}
      outside={
        <InquiryBanner threadId={threadId} variant="drawer" hide={isOpen} />
      }
      hardEdge={
        !!threadId && !isOpen
      }
      overflow="hidden"
      disabled={snoozeActive}
    >
      {!isOpen && <div className={styles.content}><TripCartSummary /></div>}
      {isOpen && (
        <div className={styles.content}>
          <PanelNavigation
            id={activePanel}
            direction={panelDirection}
          >
            {() => (
              <>
                {activePanel === TRIP_CART_PANEL_ROOT && (
                  <TripCartDrawerRoot />
                )}
                {activePanel === TRIP_CART_PANEL_CALENDAR && (
                  <TripCartPanelCalendar />
                )}
                {activePanel === TRIP_CART_PANEL_PRICE_DETAILS && (
                  <TripCartPanelPriceDetails />
                )}
              </>
            )}
          </PanelNavigation>
        </div>
      )}
    </BottomDrawer>
  );
};
export default TripCartContent;
